import { Button as AriaButton } from "react-aria-components";
import { Dropdown } from "@/components/base/dropdown/dropdown";

type PaginationEllipsisDropdownProps = {
	startPage: number;
	endPage: number;
	onPageChange: (page: number) => void;
};

export const PaginationEllipsisDropdown = ({
	startPage,
	endPage,
	onPageChange,
}: PaginationEllipsisDropdownProps) => {
	const pages = Array.from(
		{ length: endPage - startPage + 1 },
		(_, index) => startPage + index
	);

	return (
		<Dropdown.Root>
			<AriaButton
				aria-label="Abrir páginas adicionais"
				className="flex size-8 items-center justify-center rounded-lg border border-transparent bg-primary font-medium text-fg-quaternary text-sm hover:bg-primary_hover hover:text-secondary"
			>
				...
			</AriaButton>
			<Dropdown.Popover className="!w-fit !min-w-0 overflow-auto">
				<Dropdown.Menu
					aria-label="Selecionar página"
					className="max-h-[12.5rem] w-fit min-w-0 overflow-y-auto py-1"
				>
					{pages.map((page) => (
						<Dropdown.Item
							key={page}
							label={`${page}`}
							onAction={() => onPageChange(page)}
						/>
					))}
				</Dropdown.Menu>
			</Dropdown.Popover>
		</Dropdown.Root>
	);
};
